const colors = {
  rsPrimary: '#005CE6',
  error: '#E10000',
  success: '#038A00',
  abyss: '#232D54',
  slate: '#424B59',
  stone: '#6F7273',
  foam: '#FAFAFA',
  seaSalt: '#F2F2F2',
  silver: '#CDD4DA',
};

const theme = {
  color: {
    white: '#FFFFFF',
    grey500: '#333333',
    grey400: '#4F4F4F',
    grey200: '#BDBDBD',
    grey100: '#E0E0E0',
    primary300: '#6D0FA7',
    primary100: '#B649FA',
    primary300_transparent: 'rgba(109, 15, 167, 0.08)',

    // New colors
    rsPrimary: colors.rsPrimary,
    rsPrimaryTransparent: `${colors.rsPrimary}14`,
    success: colors.success,
    error: colors.error,
    neutral1: colors.abyss,
    neutral2: colors.slate,
    neutral3: colors.stone,
    background1: colors.foam,
    background2: colors.seaSalt,
    border: colors.silver,
  },
  button: {
    primary: {
      color: colors.rsPrimary,
      hover: '#589BFF',
    },
    secondary: {
      color: '#FFFFFF',
      hover: '#F5F5F5',
      border: `1px solid ${colors.silver}`,
    },
    delete: {
      color: '#CA4139',
      border: '1px solid #CA4139',
    },
  },
  fontSize: {
    small: '12px',
    normal: '14px',
    md: '16px',
    h1: '24px',
    xl: '36px',
  },
  fontWeight: {
    bold: 600,
    semiBold: 500,
  },
  iconSize: {
    small: 20,
    medium: 28,
    large: 40,
  },
  text: {
    fontFamily: 'Noto Sans',
    color: {
      primary: colors.abyss,
      secondary: colors.slate,
      disabled: '#C4C6C8',
    },
  },
  breakpoint: {
    md: '768px',
    lg: '992px',
    xl: '1200px',
  },
};

export type ThemeType = typeof theme;
export default theme;
